function ready() {
    isMobile = false;
    if (window.innerWidth >= 900) {
        return (isMobile = false);
    }
    if (window.innerWidth <= 899) {
        return (isMobile = true);
    }
}
$(document).ready(ready());
$(window).resize(function () {
    if (window.innerWidth >= 900) {
        return (isMobile = false);
    } else {
        return (isMobile = true);
    }
});
$(window)
    .resize(function () {
        var height = $(".join").height();
        var height_padding = $(".join").height() + 9;
        var sticky_sale_height = $(".join").height() + 55;
        var index_sticky_sale_height = $(".join").height() + 45;
        var sale_height = $(".join").height() + 30;
        var mobile_menu_height = $(".join").height() + 55;
        var mobile_menu_height_padded = $(".join").height() + 60;
        var mobile_menu_height_nosale = $(".join").height() + 30;
        var sticky = $(".stickyThanks")[0];
        var stickyheight = $(".stickyThanks").height();
        var sale = $(".c-coupon__textwrap")[0];
        var joinHeight = $(".join").height() - 1;
        if (sticky && sale) {
            $(".container.page-content").css("margin-top", sticky_sale_height);
            $(".menu-wrap.hidden-lg.hidden-md").css("top", mobile_menu_height);
            $(".join").css("top", stickyheight);
            $(".slideshow-owl").css("margin-top", index_sticky_sale_height);
            console.log("index sticky sale height", index_sticky_sale_height, "sticky & sale || sticky sale height", sticky_sale_height, "sale_height", sale_height, "join height", joinHeight);
        }
        if (!sale) {
            $(".slideshow-owl").css("margin-top", sale_height);
            $(".container.page-content").css("margin-top", sale_height);
            $(".menu-wrap.hidden-lg.hidden-md").css("top", sale_height);
            $(".join").css("top", "20px");
            console.log("!sale || sticky sale height", sticky_sale_height, "sale_height", sale_height, "join height", joinHeight);
        }
        if (!sticky) {
            $(".slideshow-owl").css("margin-top", joinHeight);
            $(".join").css("top", "0px !important");
            console.log("!sticky || sticky sale height", sticky_sale_height, "sale_height", sale_height, "join height", joinHeight);
        }
    })
    .resize();
function init() {
    var imgDefer = document.getElementsByTagName("img");
    for (var i = 0; i < imgDefer.length; i++) {
        if (imgDefer[i].getAttribute("data-srcset")) {
            imgDefer[i].setAttribute("src", imgDefer[i].getAttribute("data-srcset"));
        }
    }
}
window.onload = init;
function viewAs() {
    var viewGrid = $(".view-grid"),
        viewList = $(".view-list"),
        productList = $("#products-list");
    viewGrid.click(function (e) {
        productList.removeClass("list-mode");
        productList.addClass("grid-mode");
        $(this).addClass("active");
        viewList.removeClass("active");
        e.preventDefault();
    });
    viewList.click(function (e) {
        productList.removeClass("grid-mode");
        productList.addClass("list-mode");
        viewGrid.removeClass("active");
        $(this).addClass("active");
        e.preventDefault();
    });
}
jQuery(function ($) {
    "use strict";
    viewAs();
});
function showLoading() {
    $(".loading-modal").show();
}
function hideLoading() {
    $(".loading-modal").hide();
}
$(function () {
    $(".clear-cart").on("click", function (e) {
        e.preventDefault();
        $.ajax({
            type: "POST",
            url: "/cart/clear.js",
            success: function () {
                checkItemsInDropdownCart();
                updateDropdownCart();
            },
            dataType: "json",
        });
    });
});
if (window.location.href.indexOf("products" || window.location.href.indexOf("blog")) >= 0) {
    document.addEventListener(
        "DOMContentLoaded",
        function () {
            var selected = $("#product-selectors option:selected").val();
            var select_options = $("#product-selectors option").val();
            var selectorList = document.getElementById("product-selectors");
            if (selectorList) {
            } else {
                var productVariantSingle = $("#product-variants > input").val();
                Shopify.queue.unshift({ variantId: productVariantSingle });
            }
        },
        false
    );
}
function addAllItems(array) {
    Shopify.moveAlong = function () {
        if (Shopify.queue.length) {
            var request = Shopify.queue.shift();
            var quantity = 1;
            var quantityBox = parseInt(jQuery(".product-item input[name=quantity]").val());
            console.log(quantityBox, "add to bag quantity");
            var data = "id=" + request.variantId + "&quantity=" + quantity;
            var options = $.map($("#product-selectors option"), function (e) {
                return e.value;
            });
            var quantity_needle = request.variantId;
            var productVariantSingle = $("#product-variants > input").val();
            for (var i = 0; i < options.length; i++) {
                if (options[i] == quantity_needle) {
                    if (quantityBox > quantity) {
                        var data = "id=" + request.variantId + "&quantity=" + quantityBox;
                        console.log(data, quantityBox);
                    } else {
                        var data = "id=" + request.variantId + "&quantity=" + quantity;
                    }
                }
            }
            if (options.length == 0) {
                if (quantity_needle == productVariantSingle) {
                    if (quantityBox > quantity) {
                        var data = "id=" + request.variantId + "&quantity=" + quantityBox;
                    } else {
                        var data = "id=" + request.variantId + "&quantity=" + quantity;
                    }
                }
            }
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                data: data,
                beforeSend: function (index) {
                    showLoading();
                },
                success: function (res) {
                    Shopify.moveAlong();
                },
                error: function (xhr, text) {
                    if (Shopify.queue.length) {
                        Shopify.moveAlong();
                        $(".ajax-error-message").text("Please refresh and try again");
                    } else {
                        hideLoading(), $(".ajax-error-message").text($.parseJSON(xhr.responseText).description);
                        updateDropdownCart();
                        showModal(".ajax-error-modal");
                        $("div.addme").removeClass("addme2");
                    }
                },
            });
        } else {
            addToCartOk(quantity);
        }
    };
    Shopify.moveAlong();
}
function addToCartOk(quantity) {
    if(window.openCart) return monster_refresh();
    var rounds = Shopify.queue.length;
    var image = $("#ProductPhoto img").attr("src");
    var title = $("#ProductPhoto img").attr("alt");
    $(".ajax-product-image").attr("src", image);
    updateDropdownCart();
    if (Shopify.queue.length) {
        Shopify.moveAlong();
    } else {
        var options = $.map($("#product-selectors option"), function (e) {
            return e.value;
        });
        if (options.length != 0) {
            var selected = $("#product-selectors option:selected").val();
            Shopify.queue.splice(0, 1);
            Shopify.queue.unshift({ variantId: selected });
        } else {
            var productVariantSingle = $("#product-variants > input").val();
            Shopify.queue.unshift({ variantId: productVariantSingle });
        }
        var elem = $(".addme2 .addme_productimage");
        elem.each(function (index) {
            $("#addme_box").append("<img src='" + this.src + "' id='image_" + index + "'>");
        });
        $("div.addme").removeClass("addme2");
        hideLoading(), $(".ajax-success-modal").find(".btn-go-to-wishlist").hide(), $(".ajax-success-modal").find(".btn-go-to-cart").show(), $(".ajax-success-modal").find(".ajax-product-image").attr("src", image);
        setTimeout(function () {
            $("div#cart_block").addClass("open");
        }, 250);
        updateDropdownCart();
        setTimeout(function () {
            $("#addme_box").empty();
        }, 2500);
    }
}
$(function () {
    Shopify.queue = [];
    $("div.addme").on("click", function (e) {
        if ($(this).hasClass("addme2")) {
            $(this).removeClass("addme2");
            var img = $(".addme_productimage");
            var haystack = Shopify.queue;
            var needle = $(this).children("img").attr("data-productid");
            for (var i = 0; i < Shopify.queue.length; i++) {
                if (Shopify.queue[i].variantId == needle) {
                    Shopify.queue.splice(i, 1);
                    break;
                }
            }
        } else {
            $(this).addClass("addme2");
            Shopify.queue.push({ variantId: $(this).children("img").attr("data-productid") });
        }
    });
});
function checkItemsInDropdownCart() {
    if ($(".shoppingcart-box .cart-products").children().length > 0) {
        $(".shoppingcart-box .no-items").hide();
        $(".shoppingcart-box .has-items").show();
    } else {
        $(".shoppingcart-box .has-items").hide();
        $(".shoppingcart-box .no-items").show();
    }
    if ($(".shoppingcart-box .cart-products").children().length >= 1) {
        $(".shoppingcart-box .no-items").hide();
        $(".shoppingcart-box .has-items").show();
        $(".shoppingcart-box ").css("height", "100vh");
        $(".shoppingcart-box ").css("overflow", "auto");
    }
}
function doUpdateDropdownCart(cart) {
    if(window.openCart) return monster_refresh();
    var template =
        '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-collateral"><span class="price cart-collateral__price" data-price="{DATAPRICE}">{PRICE}</span> <div class="bm-cart-drawer-quantity bm-js-cart"><button class="bm-cart-drawer-quantity-minus" type="button"><i class="fas fa-minus"></i><i class="fas fa-trash"></i></button><input type="text" readonly value="{QUANTITY}"><button class="bm-cart-drawer-quantity-plus" type="button"><i class="fas fa-plus"></i></button></div></div></div></li>';
    $(".ajax_cart_quantity").text(cart.item_count);
    $(".shoppingcart-box .summary .price").html(Shopify.formatMoney(cart.total_price, window.money_format));
    $("#cart_block .cartinfo .total").html(Shopify.formatMoney(cart.total_price, window.money_format));
    $(".shoppingcart-box .cart-products").html("");
    var remainamt = 7500 - cart.total_price;
    if (cart.total_price >= 7500) {
      $(".shipping-savings-message").html("Congratulations, you've earned<br>Free Shipping!");
    } else {
      $("#shipping-remaining").html(Shopify.formatMoney(remainamt, window.money_format));
    }
    localStorage.removeItem("cartproductsid");
    localStorage.removeItem("cartproductstotal");

    if (cart.item_count > 0) {
      let proditemsList = [];
        for (var i = 0; i < cart.items.length; i++) {
            var item = template;
            item = item.replace(/\{ID\}/g, cart.items[i].id);
            item = item.replace(/\{URL\}/g, cart.items[i].url);
            item = item.replace(/\{TITLE\}/g, cart.items[i].title);
            item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
            item = item.replace(/\{IMAGE\}/g, Shopify.resizeImage(cart.items[i].image, "small"));
            item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));
            item = item.replace(/\{DATAPRICE\}/g, cart.items[i].price);
            $(".shoppingcart-box .cart-products").append(item);

            //let old_data = JSON.parse(localStorage.getItem('cartproductsid'));
            //let new_data = old_data.push(cart.items[i].id);
          
            proditemsList.push(cart.items[i].id);
            localStorage.setItem('cartproductsid',JSON.stringify(proditemsList));
        }

        $(".shoppingcart-box .bm-cart-drawer-quantity-minus.bm-remove-item").click(function (event) {
            event.preventDefault();
            var productId = $(this).parents(".item").attr("id");
            productId = productId.match(/\d+/g);
            Shopify.removeItem(productId, function (cart) {
                doUpdateDropdownCart(cart);
                var newids = removeItemOnce(proditemsList,productId);
                localStorage.setItem('cartproductsid',JSON.stringify(newids));
            });
            return false;
        });
        
        

      var totamt = Number(cart.total_price/100);
      localStorage.setItem('cartproductstotal',''+totamt);
    }
    if (cart.item_count >= 7) {
        $(".shoppingcart-box ").css("height", "100%");
        $(".shoppingcart-box ").css("overflow", "auto");
    } else {
        $(".shoppingcart-box ").css("height", "auto");
        $(".shoppingcart-box ").css("overflow", "auto");
    }
    checkItemsInDropdownCart();
    quantityUpdate();
}

function quantityUpdate() {
  // show hide remove button
  $('.bm-cart-drawer-quantity input').each(function(e){
    var cartQuantity = $(this).val();
    console.log(cartQuantity);
    if (cartQuantity == 1){
      $(this).parent('.bm-cart-drawer-quantity').find('.bm-cart-drawer-quantity-minus').addClass('bm-remove-item');
    } else {
      $(this).parent('.bm-cart-drawer-quantity').find('.bm-cart-drawer-quantity-minus').removeClass('bm-remove-item');
    }
  });
  console.log('qty-update');
  $('.bm-cart-drawer-quantity button').click(function(event){
    var oldValue = $(this).parents('.item').find('.bm-cart-drawer-quantity input').val(),
        newVal = 1;
    if($(this).hasClass('bm-cart-drawer-quantity-plus')) {
      newVal = parseInt(oldValue) + 1;
    } else if (oldValue > 1) {
        newVal = parseInt(oldValue) - 1;
    }
    $(this).parents('.item').find('.bm-cart-drawer-quantity input').text(newVal);
    $(this).parents('.item').find('.bm-cart-drawer-quantity input').val(newVal);
    console.log(newVal);
    
    if (newVal == 1){
      $(this).parent('.bm-cart-drawer-quantity').find('.bm-cart-drawer-quantity-minus').addClass('bm-remove-item');
    } else {
      $(this).parent('.bm-cart-drawer-quantity').find('.bm-cart-drawer-quantity-minus').removeClass('bm-remove-item');
    }
    console.log('ne' , newVal);

    var price = $('span.price.cart-collateral__price').data('price');
    var total_price = price * newVal;
    $('span.price.cart-collateral__price').text(Shopify.formatMoney(total_price, window.money_format));
    
    var productId = $(this).parents(".item").attr("id");
    productId = productId.match(/\d+/g);
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {
        id: productId,
        quantity: newVal
      },
      dataType: 'json',
      success: function() { 
        console.log("atc-click");
      }
    });
    
    
  });

}
function updateDropdownCart() {
    Shopify.getCart(function (cart) {
        console.log("updating the cart");
        if(window.openCart) return monster_refresh();
        doUpdateDropdownCart(cart);
    });
}
function showModal(selector) {
    $(selector).fadeIn(500);
    setTimeout(function () {
        $(selector).fadeOut(500);
    }, 2400);
}
function updatePricingQuickview() {
    var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
    var unitPriceTextMatch = $(".quickview-box .price").text().match(regex);
    if (!unitPriceTextMatch) {
        regex = /([0-9]+[.|,][0-9]+)/g;
        unitPriceTextMatch = $(".quickview-box .price").text().match(regex);
    }
    if (unitPriceTextMatch) {
        var unitPriceText = unitPriceTextMatch[0];
        var unitPrice = unitPriceText.replace(/[.|,]/g, "");
        var quantity = parseInt($(".quickview-box input[name=quantity]").val());
        var totalPrice = unitPrice * quantity;
        var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
        regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
        if (!totalPriceText.match(regex)) {
            regex = /([0-9]+[.|,][0-9]+)/g;
        }
        totalPriceText = totalPriceText.match(regex)[0];
        var regInput = new RegExp(unitPriceText, "g");
        var totalPriceHtml = $(".quickview-box .price").html().replace(regInput, totalPriceText);
        $(".quickview-box .total-price span").html(totalPriceHtml);
    }
}
function updatePricing() {
    var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
    var unitPriceTextMatch = $(".product-shop .price").text().match(regex);
    if (!unitPriceTextMatch) {
        regex = /([0-9]+[.|,][0-9]+)/g;
        unitPriceTextMatch = $(".product-shop .price").text().match(regex);
    }
    if (unitPriceTextMatch) {
        var unitPriceText = unitPriceTextMatch[0];
        var unitPrice = unitPriceText.replace(/[.|,]/g, "");
        var quantity = parseInt($(".product-shop input[name=quantity]").val());
        var totalPrice = unitPrice * quantity;
        var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
        regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
        if (!totalPriceText.match(regex)) {
            regex = /([0-9]+[.|,][0-9]+)/g;
        }
        totalPriceText = totalPriceText.match(regex)[0];
        var regInput = new RegExp(unitPriceText, "g");
        var totalPriceHtml = $(".product-shop .price").html().replace(regInput, totalPriceText);
        $(".product-shop .total-price span").html(totalPriceHtml);
    }
}
function createQuickViewVariants(product, quickviewTemplate) {
    if (product.variants.length > 1) {
        for (var i = 0; i < product.variants.length; i++) {
            var variant = product.variants[i];
            var option = '<option value="' + variant.id + '">' + variant.title + "</option>";
            quickviewTemplate.find("form.variants > select").append(option);
        }
        new Shopify.OptionSelectors("product-select-" + product.id, { product: product, onVariantSelected: selectCallbackQuickview });
        if (product.options.length == 1) {
            $(".selector-wrapper:eq(0)").prepend("<label>" + product.options[0].name + "</label>");
            for (var text = product.variants, r = 0; r < text.length; r++) {
                var s = text[r];
                if (!s.available) {
                    jQuery(".single-option-selector option")
                        .filter(function () {
                            return jQuery(this).html() === s.title;
                        })
                        .remove();
                }
            }
        }
        $(".quickview-box .selectize-input input").attr("disabled", "disabled");
        quickviewTemplate.find("form.variants .selector-wrapper label").each(function (i, v) {
            $(this).html(product.options[i].name);
        });
    } else {
        quickviewTemplate.find("form.variants > select").remove();
        var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
        quickviewTemplate.find("form.variants").append(variant_field);
    }
}
function convertToSlug(text) {
    return text
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
}
function createQuickViewVariantsSwatch(product, quickviewTemplate) {
    if (product.variants.length > 1) {
        for (var i = 0; i < product.variants.length; i++) {
            var variant = product.variants[i];
            var option = '<option value="' + variant.id + '">' + variant.title + "</option>";
            quickviewTemplate.find("form.variants > select").append(option);
        }
        new Shopify.OptionSelectors("product-select-" + product.id, { product: product, onVariantSelected: selectCallbackQuickview });
        var assetUrl = window.asset_url.substring(0, window.asset_url.lastIndexOf("mark.jpg"));
        var options = "";
        for (var i = 0; i < product.options.length; i++) {
            options += '<div class="swatch clearfix" data-option-index="' + i + '">';
            options += '<div class="header">' + product.options[i].name + "</div>";
            var is_color = false;
            if (/Color|Colour/i.test(product.options[i].name)) {
                is_color = true;
            }
            var optionValues = new Array();
            for (var j = 0; j < product.variants.length; j++) {
                var variant = product.variants[j];
                var value = variant.options[i];
                var valueHandle = convertToSlug(value);
                var forText = "swatch-" + i + "-" + valueHandle;
                if (optionValues.indexOf(value) < 0) {
                    options += '<div data-value="' + value + '" class="swatch-element ' + (is_color ? "color color-" : "") + valueHandle + (variant.available ? " available " : " soldout ") + (j == 0 ? " color-active " : "") + '">';
                    if (is_color) {
                        options += '<div class="tooltip">' + value + "</div>";
                    }
                    options += '<input id="' + forText + '" type="radio" name="option-' + i + '" value="' + value + '" ' + (j == 0 ? " checked " : "") + (variant.available ? "" : " disabled") + " />";
                    if (is_color) {
                        options +=
                            '<label for="' + forText + '" style="background-color: ' + valueHandle + "; background-image: url(" + assetUrl + valueHandle + '.jpg)"><img class="crossed-out" src="' + assetUrl + 'soldout.png" /></label>';
                    } else {
                        options += '<label for="' + forText + '">' + value + '<img class="crossed-out" src="' + assetUrl + 'soldout.png" /></label>';
                    }
                    options += "</div>";
                    if (variant.available) {
                        $('.quick-view .swatch[data-option-index="' + i + '"] .' + valueHandle)
                            .removeClass("soldout")
                            .addClass("available")
                            .find(":radio")
                            .removeAttr("disabled");
                    }
                    optionValues.push(value);
                }
            }
            options += "</div>";
        }
        quickviewTemplate.find("form.variants > select").after(options);
        quickviewTemplate.find(".swatch :radio").change(function () {
            var optionIndex = $(this).closest(".swatch").attr("data-option-index");
            var optionValue = $(this).val();
            $(this).closest("form").find(".single-option-selector").eq(optionIndex).val(optionValue).trigger("change");
        });
        if (product.available) {
            Shopify.optionsMap = {};
            Shopify.linkOptionSelectors(product);
        }
    } else {
        quickviewTemplate.find("form.variants > select").remove();
        var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
        quickviewTemplate.find("form.variants").append(variant_field);
    }
}
function loadQuickViewSlider(product, quickviewTemplate) {
    var featuredImage = Shopify.resizeImage(product.featured_image, "grande");
    quickviewTemplate
        .find(".quickview-featured-image")
        .append(
            '<a href="' +
                product.url +
                '"><img class="img-responsive" src="' +
                featuredImage +
                '" title="' +
                product.title +
                '"/><div style="height: 100%; width: 100%; top:0; left:0 z-index: 2000; position: absolute; display: none; background: url(' +
                window.loading_url +
                ') 50% 50% no-repeat;"></div></a>'
        );
    if (product.images.length > 1) {
        var quickViewCarousel = quickviewTemplate.find(".thumb-carousel");
        var count = 0;
        for (i in product.images) {
            if (count < product.images.length) {
                var grande = Shopify.resizeImage(product.images[i], "grande");
                var compact = Shopify.resizeImage(product.images[i], "compact");
                var item = '<div class="img-thumb"><a href="javascript:void(0)" data-image="' + grande + '"><img class="img-responsive" src="' + compact + '"  /></a></div>';
                quickViewCarousel.append(item);
                count = count + 1;
            }
        }
        quickViewCarousel.find("a").click(function () {
            var quickViewFeatureImage = quickviewTemplate.find(".quickview-featured-image img");
            var quickViewFeatureLoading = quickviewTemplate.find(".quickview-featured-image div");
            if (quickViewFeatureImage.attr("src") != $(this).attr("data-image")) {
                quickViewFeatureImage.attr("src", $(this).attr("data-image"));
                quickViewFeatureLoading.show();
                quickViewFeatureImage.load(function (e) {
                    quickViewFeatureLoading.hide();
                    $(this).unbind("load");
                    quickViewFeatureLoading.hide();
                });
            }
        });
    }
}
function initQuickview() {
    $(".quick-view").click(function () {
        var product_handle = $(this).attr("data-id");
        Shopify.getProduct(product_handle, function (product) {
            var template = $("#quickview-tpl").html();
            $(".quickview-box").html(template);
            var quickview = $(".quickview-box");
            quickview.find(".product-title a").html(product.title);
            quickview.find(".product-title a").attr("href", product.url);
            if (quickview.find(".product-vendor span").length > 0) {
                quickview.find(".product-vendor span").text(product.vendor);
            }
            if (quickview.find(".product-type span").length > 0) {
                quickview.find(".product-type span").text(product.type);
            }
            if (quickview.find(".product-inventory span").length > 0) {
                var variant = product.variants[0];
                var inventoryInfo = quickview.find(".product-inventory span");
                if (variant.available) {
                    if (variant.inventory_management != null) {
                        inventoryInfo.text(variant.inventory_quantity + " " + window.inventory_text.in_stock);
                    } else {
                        inventoryInfo.text(window.inventory_text.many_in_stock);
                    }
                } else {
                    inventoryInfo.text(window.inventory_text.out_of_stock);
                }
            }
            if (product.description.indexOf("[countdown]") > 0) {
                var countdownTime = product.description.match(/\[countdown\](.*)\[\/countdown\]/);
                if (countdownTime && countdownTime.length > 0) {
                    quickview.find(".countdown").show();
                    quickview.find(".quickview-clock").countdown(countdownTime[1], function (event) {
                        $(this).html(event.strftime("%Dd %H:%M:%S"));
                    });
                }
            }
            if (quickview.find(".product-description").length > 0) {
                var description = product.description.replace(/(<([^>]+)>)/gi, "");
                var description = description.replace(/\[countdown\](.*)\[\/countdown\]/g, "");
                description = description.split(" ").splice(0, 20).join(" ") + "...";
                quickview.find(".product-description").text(description);
            } else {
                quickview.find(".product-description").remove();
            }
            quickview.find(".price").html(Shopify.formatMoney(product.price, window.money_format));
            quickview.find(".product-item").attr("id", "product-" + product.id);
            quickview.find(".variants").attr("id", "product-actions-" + product.id);
            quickview.find(".variants select").attr("id", "product-select-" + product.id);
            if (product.compare_at_price > product.price) {
                quickview.find(".compare-price").html(Shopify.formatMoney(product.compare_at_price_max, window.money_format)).show();
                quickview.find(".price").addClass("on-sale");
            } else {
                quickview.find(".compare-price").html("");
                quickview.find(".price").removeClass("on-sale");
            }
            if (!product.available) {
                quickview.find("select, input, .total-price, .dec, .inc, .variants label").remove();
                quickview.find(".add-to-cart-btn").text(window.inventory_text.unavailable).addClass("disabled").attr("disabled", "disabled");
            } else {
                quickview.find(".total-price span").html(Shopify.formatMoney(product.price, window.money_format));
                if (window.use_color_swatch) {
                    createQuickViewVariantsSwatch(product, quickview);
                } else {
                    createQuickViewVariants(product, quickview);
                }
            }
            quickview.find(".button").on("click", function () {
                var oldValue = quickview.find(".quantity").val(),
                    newVal = 1;
                if ($(this).text() == "+") {
                    newVal = parseInt(oldValue) + 1;
                } else if (oldValue > 1) {
                    newVal = parseInt(oldValue) - 1;
                }
                quickview.find(".quantity").val(newVal);
                if (quickview.find(".total-price").length > 0) {
                    updatePricingQuickview();
                }
            });
            if (window.enable_multiple_currencies) {
                Currency.convertAll(window.shop_currency, jQuery(".selected-currency").html(), "span.money", "money_format");
            }
            loadQuickViewSlider(product, quickview);
            if ($(".quickview-box .add-to-cart-btn").length > 0) {
                $(".quickview-box .add-to-cart-btn").click(function () {
                    var variant_id = $(".quickview-box select[name=id]").val();
                    if (!variant_id) {
                        variant_id = $(".quickview-box input[name=id]").val();
                    }
                    var quantity = $(".quickview-box input[name=quantity]").val();
                    if (!quantity) {
                        quantity = 1;
                    }
                    var title = $(".quickview-box h2.product-title a").html();
                    var image = $(".quickview-box .quickview-featured-image img").attr("src");
                    AjaxAddToCart(variant_id, quantity, title, image);
                    $(".quickview-box").fadeOut(500);
                });
            }
            $(".quickview-box").fadeIn(500);
            if ($(".quickview-box .total-price").length > 0) {
                $(".quickview-box input[name=quantity]").on("change", updatePricingQuickview);
            }
            quickview.find(".thumb-carousel").owlCarousel({ items: 3, dots: false, nav: true, rewindNav: true });
        });
        return false;
    });
    $(".quickview-box .overlay, .close-window").click(function () {
        $(".quickview-box").fadeOut(500);
        return false;
    });
}
jQuery(function ($) {
    "use strict";
    $(".continue-shopping").click(function () {
        $(".ajax-success-modal").fadeOut(500);
    });
    $(".close-modal, .overlay").click(function () {
        $(".ajax-success-modal").fadeOut(500);
    });
    $(".shoppingcart-box .btn-remove").click(function (event) {
        event.preventDefault();
        var productId = $(this).parents(".item").attr("id");
        productId = productId.match(/\d+/g);
        Shopify.removeItem(productId, function (cart) {
            doUpdateDropdownCart(cart);
        });
        return false;
    });
    $(".quantity-cart .button").on("click", function () {
        var oldValue = $(".quantity-cart .quantity").val(),
            newVal = 1;
        if ($(this).data("symbol") == "plus") {
            newVal = parseInt(oldValue) + 1;
        } else if (oldValue > 1) {
            newVal = parseInt(oldValue) - 1;
        }
        $(".quantity-cart .quantity").val(newVal);
        if ($(".product-shop .total-price").length > 0) {
            updatePricing();
        }
    });
    $(".add-to-cart-btn").click(function (event) {
        event.preventDefault();
        var productId = $(this).attr("data-productid");
        var variant_id = $("#product-actions-" + productId + " select[name=id]").val();
        if (!variant_id) {
            variant_id = $("#product-actions-" + productId + " input[name=id]").val();
        }
        var quantity = $("#product-actions-" + productId + " input[name=quantity]").val();
        if (!quantity) {
            quantity = 1;
        }
        if (/blog/.test(window.location.href)) {
            var image = $("#product-actions-" + productId + " input[name=image]").val();
            var variant_id = $("#product-actions-" + productId + " input[name=variant]").val();
            var title = $(".product-shop .product-title").html();
        }
        // let checkQuantity = setInterval(function() {
        //   if ($('.bm-cart-drawer-quantity.bm-js-cart button').length) {
        //     quantityUpdate();
        //     clearInterval(checkQuantity);
        //   }
        // }, 2000);
        
        return false;
    });
});
$(window).load(function () {
    checkItemsInDropdownCart();
    initQuickview();
    if (window.enable_multiple_currencies && window.shop_currency != jQuery(".selected-currency").html()) {
        Currency.convertAll(window.shop_currency, jQuery(".selected-currency").html(), "span.money", "money_format");
    }
});
$(document).on("click", ".overlay, .close-window", function () {
    $(".quickview-box").fadeOut(500);
    return false;
});
$(".swatch :radio").change(function () {
    var optionIndex = $(this).closest(".swatch").attr("data-option-index");
    var optionValue = $(this).val();
    $(this).closest("form").find(".single-option-selector").eq(optionIndex).val(optionValue).trigger("change");
});
Shopify.optionsMap = {};
Shopify.updateOptionsInSelector = function (selectorIndex) {
    switch (selectorIndex) {
        case 0:
            var key = "root";
            var selector = $(".single-option-selector:eq(0)");
            break;
        case 1:
            var key = $(".single-option-selector:eq(0)").val();
            var selector = $(".single-option-selector:eq(1)");
            break;
        case 2:
            var key = $(".single-option-selector:eq(0)").val();
            key += " / " + $(".single-option-selector:eq(1)").val();
            var selector = $(".single-option-selector:eq(2)");
    }
    var initialValue = selector.val();
    selector.empty();
    var availableOptions = Shopify.optionsMap[key];
    if (availableOptions && availableOptions.length) {
        for (var i = 0; i < availableOptions.length; i++) {
            var option = availableOptions[i];
            var newOption = $("<option></option>").val(option).html(option);
            selector.append(newOption);
        }
        $('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function () {
            if ($.inArray($(this).attr("data-value"), availableOptions) !== -1) {
                $(this).removeClass("soldout").show().find(":radio").removeAttr("disabled", "disabled").removeAttr("checked");
            } else {
                $(this).addClass("soldout").hide().find(":radio").removeAttr("checked").attr("disabled", "disabled");
            }
        });
        if ($.inArray(initialValue, availableOptions) !== -1) {
            selector.val(initialValue);
        }
        selector.trigger("change");
    }
};
Shopify.linkOptionSelectors = function (product) {
    for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        if (variant.available) {
            Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
            Shopify.optionsMap["root"].push(variant.option1);
            Shopify.optionsMap["root"] = Shopify.uniq(Shopify.optionsMap["root"]);
            if (product.options.length > 1) {
                var key = variant.option1;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option2);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
            if (product.options.length === 3) {
                var key = variant.option1 + " / " + variant.option2;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option3);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
        }
    }
    Shopify.updateOptionsInSelector(0);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    $(".single-option-selector:eq(0)").change(function () {
        Shopify.updateOptionsInSelector(1);
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true;
    });
    $(".single-option-selector:eq(1)").change(function () {
        Shopify.updateOptionsInSelector(0);
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true;
    });
};
jQuery(function ($) {
    "use strict";
    var productCarousel = $(".about-carousel");
    if (productCarousel.length > 0)
        productCarousel.each(function () {
            var items = 1,
                itemsDesktop = 1,
                itemsDesktopSmall = 1,
                itemsTablet = 1,
                itemsMobile = 1;
            var rtl = false;
            if ($("body").hasClass("rtl")) rtl = true;
            $(this).owlCarousel({
                responsiveClass: true,
                responsive: { 1550: { items: items }, 1199: { items: itemsDesktop }, 991: { items: itemsDesktopSmall }, 767: { items: itemsTablet }, 318: { items: itemsMobile } },
                rtl: rtl,
                autoPlay: false,
                nav: true,
                dots: false,
                pagination: false,
            });
        });
});
// Click function
$("#tabs-nav li").click(function () {
    $("#tabs-nav li, .tab-content").removeClass("active");
    $(this).addClass("active");
    var activeTab = $(this).find("a").attr("href");
    $(activeTab).addClass("active");
    return false;
});

$(".mini-cart-close-section").click(function () {
    $("div#cart_block").removeClass("open");
});

$(".dropdown-menu .no-items, .dropdown-menu .has-items").click(function (event) {
  	event.stopPropagation();
  	$("div#cart_block").addClass("open");
});

function removeItemOnce(arr, value) {
  var index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
}

// starts collections page add to cart button with variation

$( document ).ready(function() {
  var product_varid = '0';
  //$('.add-to-cart').click(function () {
  $('body').on( 'click', '.add-to-cart', function () {
  $('.popup-variants-main').removeClass('display-b');
  product_url = $(this).data('url');
  product_id = $(this).data('prdid');
  btn_prod_id = '#'+product_id;
  product_url += ".js";
  jQuery.getJSON(product_url, function(product){
    $('#'+product.id).empty();
    for (var i = 0; i < product.variants.length; i++) {
      var variantname = product.variants[i].title;
      var isavailable = product.variants[i].available;
      var cssclass = '';
      if(isavailable){
        cssclass ="add-to-cart-hasclass";
      }
      else{
        cssclass ="out-of-stock";
      }
      
      if($.trim(variantname) != 'Default Title'){
        	$('<li class='+cssclass+' data-value='+product.variants[i].id+' data-pid='+product.id+'>').text(product.variants[i].title).appendTo('#'+product.id);
      }
      else{
        product_varid = product.variants[0].id;
      }
    }
    });
    setTimeout(() => {
     if($(btn_prod_id).parent().find('li').hasClass("add-to-cart-hasclass")) {
    	$(btn_prod_id).parent().parent().addClass('display-b');
      }
   	  else{
      	getAjaxcart(product_varid);
      }
    }, "1000");
  });

    //$('.variant-popup-close i').click(function () {
     $(document).on('click', '.variant-popup-close i', function(){    
		$('.popup-variants-main').removeClass('display-b');
    });

	$(document).on('click', 'li.add-to-cart-hasclass', function(){
    	var list_variant_id = $(this).data('value');
      	getAjaxcart(list_variant_id);
      	$('.popup-variants-main').removeClass('display-b');
      	//console.log(list_variant_id);
    });
    $(document).on( 'click', '.real-previous, .real-button, .real-next, .paginate-show-button', function () {
      $('html,body').animate({ scrollTop: 100 }, 'slow');
    });
});

function getAjaxcart(productid){
  var data = "id=" + productid + "&quantity=1";
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: data,
        beforeSend: function (index) {
          //showLoading();
        },
        success: function (res) {
          updateDropdownCart();
          $("div#cart_block").addClass("open");
        },
        error: function (xhr, text) {
          if (Shopify.queue.length) {
            showModal(".ajax-error-modal");
            $(".ajax-error-message").text($.parseJSON(xhr.responseText).description);
          } else {
            //hideLoading();
            $(".ajax-error-message").text($.parseJSON(xhr.responseText).description);
            updateDropdownCart();
            showModal(".ajax-error-modal");
            $('.popup-variants-main').removeClass('display-b');
          }
        },
    });
}

// end collections page add to cart button with variation

// Start - stamped star rating fix for collection page
function bmFixStarRatingCollection() {
    if (StampedFn) {
        StampedFn.loadBadges();
    }
    
    var targetNode = document.querySelector('.template-collection #collection-hb');
    if (targetNode) {
        var config = { childList: true };

        function callback(mutationList, observer) {
        for (var mutation of mutationList) {
            if (mutation.type === "childList") {
                if (StampedFn) {
                    StampedFn.loadBadges();
                }
            }
        }
        };

        var observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }
}

if (window.location.href.indexOf('/collections/') > -1 && window.location.href.indexOf('/products/') <= -1 && document.body.classList.contains('template-collection')) {
    document.addEventListener('DOMContentLoaded', bmFixStarRatingCollection);
}
// End - stamped star rating fix for collection page